// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-input.is-disabled .el-input__inner {\n  color: #666 !important;\n}\n.el-textarea.is-disabled .el-textarea__inner {\n  color: #666 !important;\n}\n.el-range-editor.is-disabled input {\n  color: #666 !important;\n}\n.vxe-form--item-trigger-node {\n  min-width: 90px !important;\n  color: #333 !important;\n  font-weight: bold !important;\n}\n.vxe-form--item-trigger-text {\n  font-size: 13px;\n}\n.vxe-form--item-trigger-icon {\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
